<ng-container *ngIf="cardToken$ | async as cardToken; else addCard">
  <div
    class="ecash-button d-flex justify-content-between align-item-center bg-primary"
    [ngClass]="{
      'bg-frozen border-frozen': cardToken.Frozen,
      'stand-alone': !isMemberCard,
    }"
  >
    <div class="d-flex align-items-center">
      <ng-container *ngIf="!cardToken.CardIssuer">
        <ng-container [ngSwitch]="cardToken!.CardType">
          <img class="payment-logo" *ngSwitchCase="1" src="assets/images/payment-icons/_Mastercard.svg" />
          <img class="payment-logo" *ngSwitchCase="2" src="assets/images/payment-icons/_AMEX.svg" />
          <img class="payment-logo" *ngSwitchCase="3" src="assets/images/payment-icons/_Visa.svg" />
          <img class="payment-logo" *ngSwitchCase="4" src="assets/images/payment-icons/_Discover.svg" />
          <img class="payment-logo" *ngSwitchCase="5" src="assets/images/payment-icons/_JCB.svg" />
          <img class="payment-logo" *ngSwitchCase="7" src="assets/images/payment-icons/_DinnersClub.svg" />
          <img class="payment-logo" *ngSwitchCase="8" src="assets/images/payment-icons/_UnionPay.svg" />
          <div class="payment-logo" *ngSwitchDefault></div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="cardToken.CardIssuer == cardIssuerProvider">
        <img class="cb-logo" src="assets/images/footer/CentralBank-Vertical.png" />
      </ng-container>
      <div class="ecash-text text-white">({{ cardToken?.CardNumber.substring(12) }})</div>

      <div class="expiried-status" *ngIf="isExpiried(cardToken?.ExpiryDate); else notExpiried">
        {{ 'card.token.expiried' | translate: { fgbdefault: 'EXPIRED' } }}
      </div>
      <ng-template #notExpiried>
        <div class="expiried-status text-white">
          {{ 'card.token.expiry' | translate: { fgbdefault: 'EXP: ' } }}
          {{ cardToken?.ExpiryDate | date: 'MM/yy' }}
        </div></ng-template
      >
    </div>

    <div class="card-token-number text-white">
      <a class="d-flex text-white" [ngClass]="{ 'text-white': cardToken.Frozen }" [routerLink]="'/payment'">
        <span class="icon material-icons text-white">chevron_right</span>
      </a>
    </div>
  </div>
</ng-container>

<ng-template #addCard>
  <div
    class="ecash-button d-flex justify-content-center align-item-center bg-primary"
    [ngClass]="{ 'stand-alone': !isMemberCard }"
  >
    <a class="btn d-flex align-item-center text-white p-0" [routerLink]="'/payment'">
      <span class="icon material-icons pe-2">add_card</span>
      <span class="font-size-14 add-card-text">{{ 'member.card.ecash.add' | translate }}</span>
      <span class="icon material-icons ps-1">chevron_right</span>
    </a>
  </div>
</ng-template>
